export default __webpack_public_path__ + "6e1f09997e702ba5a8d5aed30a226a3b.ogg";